const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#009633',
                hover: '#1c6d25'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
